// extracted by mini-css-extract-plugin
module.exports = {"container":"input-module__container___zfVcJ","disabled":"input-module__disabled___MKFmn","dark":"input-module__dark___2tKKo"};